import { render, staticRenderFns } from "./orgDrawer.vue?vue&type=template&id=32a91b4c&"
import script from "./orgDrawer.vue?vue&type=script&lang=js&"
export * from "./orgDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports